import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from './services/config.service';
import { RouterhistoryService } from './services/routerhistory.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent{
  title = 'Vaillant-Simulator';

  constructor(private routerHistory: RouterhistoryService){
  	
  }
}
